import { Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Button, TextField, Pagination } from "@mui/material";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import "./account.css";
import { theme } from "../../theme";
import React, { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";

function Promo() {
    const [load, setLoad] = useState(true);
    const [isShow, setShow] = useState(false);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    
    // Khai báo State cho Phân trang
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 10; // Số lượng hiển thị trên 1 trang

    // Cấu hình gửi kèm Token bảo mật
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    const [promo, setPromo] = useState(null);
    const [promoList, setPromoList] = useState(null);

    // Lấy danh sách Khuyến mãi từ Backend
    useEffect(() => {
        if (load === true) {
            axios.get(`${process.env.REACT_APP_API_URL}/promo/get?page=${page}&limit=${limit}`).then((res) => {
                if (res.data.success) {
                    setPromoList(res.data.data);
                    setTotalPages(res.data.totalPages || 1); // Cập nhật tổng số trang
                }
                setLoad(false);
            }).catch(() => setLoad(false));
        }
    }, [load, page]);

    // Hàm xử lý khi bấm sang trang khác
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setLoad(true); // Bật loading xoay xoay khi chuyển trang
    };

    // Hàm Thêm Mã Mới
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoad(true); 
        const formData = {
            code: e.target.code.value,
            num: Number(e.target.num.value),
            money: Number(e.target.money.value)
        };
        axios.post(`${process.env.REACT_APP_API_URL}/promo/create`, formData)
            .then((res) => {
                swal(t('success'), "", "success").then(() => {
                    setPage(1); // Tự động nhảy về trang 1 để xem mã vừa thêm
                    setLoad(true);
                    e.target.reset(); // Làm trống form
                });
            })
            .catch(() => {
                swal(t("error"), "", "error");
                setLoad(false);
            });
    };

    // Hàm Sửa Mã
    const handleSubmitnotify = (e) => {
        e.preventDefault();
        setLoad(true);
        const formData = {
            id: promo._id,
            code: e.target.code.value,
            num: Number(e.target.num.value),
            money: Number(e.target.money.value)
        };

        axios.post(`${process.env.REACT_APP_API_URL}/promo/edit`, formData).then((res) => {
            swal(t('success'), "", "success").then(() => {
                setLoad(true);
                setShow(false); // Đóng form sửa
            });
        }).catch(() => {
            swal(t("error"), "", "error");
            setLoad(false);
        });
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                {profile?.permission?.full == 1 ? (
                    <Box component="main" sx={{ flexGrow: 1, py: 8, position: "relative" }}>
                        
                        {/* HIỆU ỨNG LOADING TRỞ TÂM MÀN HÌNH */}
                        {load && (
                            <div className="loading" style={{ maxWidth: "100%", zIndex: 9999 }}>
                                <div className="loader"></div>
                            </div>
                        )}

                        <Container maxWidth={false}>
                            <div style={{ fontSize: "25px", fontWeight: 700 }}>{t("setting_promo")}</div>
                            
                            {/* FORM THÊM MỚI */}
                            <div style={{ marginTop: "20px" }}>
                                <form onSubmit={handleSubmit} className="form-admin" style={{ maxWidth: "400px" }}>
                                    <div>
                                        <label>{t("code_promo")}</label>
                                        <input required name="code" id="code" />
                                    </div>
                                    <div>
                                        <label>{t("code_uses")}</label>
                                        <input name="num" id="num" type="number" required placeholder="Nhập số lượt sử dụng" />
                                    </div>
                                    <div>
                                        <label>{t("money")}</label>
                                        <input name="money" id="money" type="number" required placeholder="Nhập số tiền" />
                                    </div>
                                    <div>
                                        <button className="btn_setting">{t("add_new")}</button>
                                    </div>
                                </form>
                            </div>

                            {/* BẢNG DANH SÁCH MÃ KHUYẾN MÃI */}
                            <div className="form_set">
                                <Box>
                                    <Table sx={{ width: "100%", minWidth: "60vw" }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ padding: "10px" }}>{t("code_promo")}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Đã dùng / Tổng</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{t("money")}</TableCell>
                                                <TableCell style={{ textAlign: "center" }}>{t("more")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {promoList && promoList.length > 0 ? (
                                                promoList.map((item) => {
                                                    // Tính toán logic hiển thị Đã dùng / Tổng
                                                    // Nếu mã cũ chưa có max thì lấy num làm max tạm
                                                    const maxCount = item.max || item.num || 0; 
                                                    const currentNum = item.num || 0;
                                                    const usedCount = maxCount - currentNum; 
                                                    
                                                    // Bôi đỏ nếu số lượt còn lại (num) <= 0
                                                    const isSoldOut = currentNum <= 0;

                                                    return (
                                                        <TableRow key={item._id}>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px", maxWidth: "200px", wordBreak: "break-word" }}>
                                                                {item.code}
                                                            </TableCell>

                                                            <TableCell sx={{ 
                                                                fontWeight: "bold", 
                                                                padding: "10px",
                                                                color: isSoldOut ? "#d32f2f" : "#2e7d32" // Đỏ nếu hết, Xanh lá nếu còn
                                                            }}>
                                                                {usedCount} / {maxCount}
                                                            </TableCell>

                                                            <TableCell sx={{ fontWeight: "600", padding: "10px", maxWidth: "40vw", wordBreak: "break-word" }}>
                                                                {item.money?.toLocaleString("vi-VN")}
                                                            </TableCell>
                                                            
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px", textAlign: "center" }}>
                                                                <Button
                                                                    className="btn-lock"
                                                                    onClick={() => {
                                                                        swal({
                                                                            title: "Bạn có chắc chắn?",
                                                                            text: "Xóa mã này sẽ không thể khôi phục!",
                                                                            icon: "warning",
                                                                            buttons: true,
                                                                            dangerMode: true,
                                                                        }).then((willDelete) => {
                                                                            if (willDelete) {
                                                                                setLoad(true);
                                                                                axios.post(`${process.env.REACT_APP_API_URL}/promo/delete`, { id: item._id })
                                                                                    .then((res) => {
                                                                                        swal(t("success"), "", "success");
                                                                                        setLoad(true);
                                                                                    })
                                                                                    .catch(() => setLoad(false));
                                                                            }
                                                                        });
                                                                    }}>
                                                                    {t("delete")}
                                                                </Button>
                                                                <Button
                                                                    onClick={() => {
                                                                        setPromo(item);
                                                                        setShow(true);
                                                                    }}
                                                                    sx={{ ml: 1 }}>
                                                                    {t("edit")}
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={4} style={{ fontSize: "16px", textAlign: "center", padding: "20px" }}>
                                                        Không có dữ liệu
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </div>

                            {/* THANH PHÂN TRANG */}
                            {totalPages > 1 && (
                                <Box sx={{ display: "flex", justifyContent: "center", pt: 3, pb: 3 }}>
                                    <Pagination
                                        color="primary"
                                        count={totalPages}
                                        page={page}
                                        onChange={handleChangePage}
                                    />
                                </Box>
                            )}

                            {/* FORM MODAL CHỈNH SỬA */}
                            {isShow === true && promo != null && (
                                <div className="modal">
                                    <div className="modaloverlay" onClick={() => setShow(false)}></div>
                                    <div style={{ backgroundColor: "white", width: "600px", zIndex: 10 }} className="modalbody">
                                        <form onSubmit={handleSubmitnotify}>
                                            <div className="modalinner">
                                                <div className="modalheader">{t("edit")} - {promo.code}</div>
                                                <div className="modalform">
                                                    <div className="modalformgroup" style={{ padding: "9px" }}>
                                                        <TextField
                                                            name="code"
                                                            defaultValue={promo.code}
                                                            sx={{ width: "100%" }}
                                                            type="text"
                                                            required
                                                            label={t("code_promo")}
                                                        />
                                                    </div>
                                                    <div className="modalformgroup" style={{ padding: "9px" }}>
                                                        <TextField
                                                            name="num"
                                                            defaultValue={promo.num}
                                                            sx={{ width: "100%" }}
                                                            type="number"
                                                            required
                                                            label={t("code_uses")}
                                                        />
                                                    </div>
                                                    <div className="modalformgroup" style={{ padding: "9px" }}>
                                                        <TextField
                                                            name="money"
                                                            defaultValue={promo.money}
                                                            sx={{ width: "100%" }}
                                                            type="number"
                                                            required
                                                            label={t("money")}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="item_btn_form" style={{ marginTop: "15px" }}>
                                                    <div className="modalformcontrols">
                                                        <Button variant="contained" type="submit">{t("submit")}</Button>
                                                    </div>
                                                    <div className="modalformcontrols">
                                                        <Button variant="outlined" onClick={() => setShow(false)}>{t("close")}</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            )}
                        </Container>
                    </Box>
                ) : (
                    <Box sx={{ p: 3 }}>{t("not_permission")}</Box>
                )}
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default Promo;